// extracted by mini-css-extract-plugin
export default {"container":"ProductsManager_container__V2TR1"};